export const mockServices = [
  {
    id: 1,
    name: 'Waterproofing Services',
    description: 'Expert waterproofing solutions for bathrooms, balconies, terraces, underground tanks, and overhead tanks. Prevent leaks and water damage with our professional services.',
    icon: 'Droplet',
    image: 'https://customer-assets.emergentagent.com/job_d715e127-673d-402c-8a56-d9b15a0f1ccd/artifacts/5pbjxvj6_leakproof-waterproofing-services-bibiganj-patna-4cjghib6mm-250.jpg',
    featured: true
  },
  {
    id: 2,
    name: 'Structural Repair Services',
    description: 'Comprehensive structural repair and strengthening solutions. We handle concrete repairs, foundation work, and building restoration with precision.',
    icon: 'Wrench',
    image: 'https://customer-assets.emergentagent.com/job_d715e127-673d-402c-8a56-d9b15a0f1ccd/artifacts/72el34du_hq720%20%281%29.jpg',
    featured: false
  },
  {
    id: 3,
    name: 'Plumbing Services',
    description: 'Professional plumbing installation, repair, and maintenance services. From simple fixes to complete plumbing systems.',
    icon: 'Wrench',
    image: 'https://customer-assets.emergentagent.com/job_d715e127-673d-402c-8a56-d9b15a0f1ccd/artifacts/aqjyfoi7_plumbers-at-work-stockcake.jpg',
    featured: false
  },
  {
    id: 4,
    name: 'Carpenter Services',
    description: 'Skilled carpentry work including furniture, doors, windows, and custom woodwork. Quality craftsmanship guaranteed.',
    icon: 'Hammer',
    image: 'https://customer-assets.emergentagent.com/job_d715e127-673d-402c-8a56-d9b15a0f1ccd/artifacts/m785rfs6_IMG_20260103_204000.jpg',
    featured: false
  },
  {
    id: 5,
    name: 'Architect Services',
    description: 'Professional architectural design and planning services. Transform your vision into detailed, executable plans.',
    icon: 'Ruler',
    image: 'https://customer-assets.emergentagent.com/job_d715e127-673d-402c-8a56-d9b15a0f1ccd/artifacts/nmx0cwj8_image-engineering-objects-workplace-top-view-construction-concept-engineering-tools-vintage-tone-retro-filter-effect-soft-focus-selective-focus-1542x1080.webp',
    featured: false
  },
  {
    id: 6,
    name: 'Construction Services',
    description: 'Complete construction solutions from ground up. Residential and commercial projects executed with excellence.',
    icon: 'Building2',
    image: 'https://customer-assets.emergentagent.com/job_d715e127-673d-402c-8a56-d9b15a0f1ccd/artifacts/lqc49q4p_Screenshot_20260103_203716.jpg',
    featured: false
  },
  {
    id: 7,
    name: 'Rebaring Services',
    description: 'Expert steel reinforcement work for concrete structures. Ensuring strength and durability in every project.',
    icon: 'Construction',
    image: 'https://customer-assets.emergentagent.com/job_d715e127-673d-402c-8a56-d9b15a0f1ccd/artifacts/mexqwmy2_IMG_20260103_212610.jpg',
    featured: false
  },
  {
    id: 8,
    name: 'Slab Cutting Services',
    description: 'Precision concrete slab cutting services using advanced equipment. Clean cuts for renovations and modifications.',
    icon: 'Scissors',
    image: 'https://customer-assets.emergentagent.com/job_d715e127-673d-402c-8a56-d9b15a0f1ccd/artifacts/uwbm71bc_product-jpeg-500x500%20%281%29.jpg',
    featured: false
  },
  {
    id: 9,
    name: 'Core Cutting Services',
    description: 'Professional core cutting for concrete and masonry. Perfect for creating openings for pipes, ducts, and cables.',
    icon: 'Circle',
    image: 'https://customer-assets.emergentagent.com/job_d715e127-673d-402c-8a56-d9b15a0f1ccd/artifacts/ddzxk8bx_IMG_20260103_203939.jpg',
    featured: false
  },
  {
    id: 10,
    name: 'Painting Services',
    description: 'Interior and exterior painting services with premium quality paints. Transform your spaces with professional finishing.',
    icon: 'Paintbrush',
    image: 'https://customer-assets.emergentagent.com/job_d715e127-673d-402c-8a56-d9b15a0f1ccd/artifacts/ywct13qq_82WCMDuQ1568106430.jpg',
    featured: false
  }
];

export const mockTeam = [
  {
    id: 1,
    name: 'Er. Sandeep Sangral',
    role: 'Technical Expert',
    phone: '+91 9149762527',
    services: 'All Services'
  },
  {
    id: 2,
    name: 'Sahil Kumar',
    role: 'Founder and Site Manager',
    phone: '8803509860',
    services: 'All Services'
  }
];

export const mockQuotes = [];

export const companyInfo = {
  name: 'Structure Savers',
  tagline: 'Waterproofing Specialists & Construction Experts',
  address: 'W/no. 1 near Axis Bank, Bari Brahmna, District Samba',
  email: 'structuresavers@gmail.com',
  phone: '+91 9149762527',
  alternatePhone: '8803509860'
};